const STYLES = {
  draft: "bg-slate-100 text-slate-600 border-slate-300",
  sent: "bg-blue-50 text-blue-700 border-blue-200",
  viewed: "bg-amber-100 text-amber-700 border-amber-200",
  accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-red-50 text-red-600 border-red-200",
};

export const StatusBadge = ({ status }) => (
  <span
    data-testid="quote-status-badge"
    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border capitalize ${
      STYLES[status] || STYLES.draft
    }`}
  >
    {status}
  </span>
);

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6">
    <div>
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900"
        style={{ fontFamily: "Manrope, sans-serif" }}>
        {title}
      </h1>
      {subtitle && <p className="text-sm text-slate-500 mt-1.5">{subtitle}</p>}
    </div>
    <div className="flex items-center gap-2">{children}</div>
  </div>
);

export const EmptyState = ({ icon: Icon, title, description, action }) => (
  <div className="flex flex-col items-start gap-3 rounded-md border border-dashed border-slate-300 bg-white px-6 py-12">
    {Icon && <Icon size={22} className="text-slate-400" />}
    <div>
      <p className="font-semibold text-slate-800">{title}</p>
      <p className="text-sm text-slate-500 mt-1">{description}</p>
    </div>
    {action}
  </div>
);
